import React from 'react';
import './messages.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
const messageTypes = [
  'info', // Blue (Default)
  'error', // Red
  'warning', // Yellow
  'success', // Green
  'pre-order', // white background with black text
  'toast', // black background with white text
];
const Messages = props => {
  const {
    message,
    banner,
    truncate,
    actionable,
    actionText,
    onAction,
    reversePresale,
    webClassName,
    icon,
    messageStyle,
    iconStyle = 'lefticon--iconImg',
  } = props;
  let { type } = props;
  if (messageTypes.indexOf(type) < 0) type = 'info';
  const _getClasses = () => {
    const classes = [
      'hb-messages',
      'justify-content--space-between',
      `message-type--${type}`,
      webClassName,
    ];
    if (banner) classes.push('message-banner');
    if (truncate) classes.push('message-truncate');
    if (reversePresale) classes.push('reverse-presale');
    return classes.join(' ');
  };

  let actionItem = null;
  let leftIcon = null;
  if (actionable && actionText && onAction) {
    if (typeof onAction === typeof '') {
      actionItem = (
        <Link className="message-action" to={onAction}>
          {actionText}
        </Link>
      );
    } else if (typeof onAction === 'function') {
      actionItem = (
        <span
          className="message-action"
          onClick={e => onAction(e, { ...props })}
        >
          {actionText}
        </span>
      );
    }
  }
  if (icon) {
    leftIcon = (
      <span className="lefticon">
        <img className={iconStyle} src={icon} />
      </span>
    );
  }

  return (
    <div className={_getClasses()}>
      {leftIcon && leftIcon}
      <span className={messageStyle}>{message}</span>
      {actionItem && actionItem}
    </div>
  );
};

Messages.propTypes = {
  type: PropTypes.oneOf(messageTypes),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  banner: PropTypes.bool, // full width
  truncate: PropTypes.bool, // Truncate in one line
  dismissible: PropTypes.bool, // Show [X] button and dismiss when click
  actionable: PropTypes.bool,
  actionText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onAction: PropTypes.oneOfType([
    PropTypes.string, // if string, creates a link,
    PropTypes.func, // if function, creates cb function with instance of event and all props
  ]),
  reversePresale: PropTypes.bool, // flag to change the look of pre-sale tag on cart with errors
};

Messages.defaultProps = {
  type: 'info',
  message: null,
  banner: false,
  truncate: false,
  dismissible: false,
  actionable: false,
  onAction: null,
  reversePresale: null,
  webClassName: '',
};

export default Messages;
